import React, { useState, useCallback, useEffect } from "react";
import { practiceparagraphs } from './Paragraphs';
import Characters from "./Characters";
import CenteredMessage from "./CenteredMessage";
import { BsArrowLeft } from "react-icons/bs";
import { Link } from 'react-router-dom';

let ranIndex = Math.floor(Math.random() * practiceparagraphs.length);

const ErrorMode = () => {
  const [word, setWord] = useState('');
  const [para, setPara] = useState(practiceparagraphs[ranIndex]);
  const [showNotification, setShowNotification] = useState(false);
  const [chrIndex, setChrIndex] = useState(0);
  const [WPM, setWPM] = useState(0);
  const [errors, setErrors] = useState(0);

  const handleWordType = (e) => {
    const { value } = e.target;
    setWord(value);
    setChrIndex(value.length);

    const wordsTyped = (value.length - errors) / 5;
    setWPM(Math.max(wordsTyped, 0)); // Ensure WPM is not below 0

    const lastChar = value[value.length - 1];
    if (lastChar && para[value.length - 1] !== lastChar) {
      setErrors(prevErrors => prevErrors + 1);
    }
  };

  useEffect(() => {
    if (errors >= 1) {
      setShowNotification(true);
    }
  }, [errors]);

  const handleCloseNotification = () => {
    setShowNotification(false);
    setWord('');
    setPara(practiceparagraphs[Math.floor(Math.random() * practiceparagraphs.length)]);
    setChrIndex(0);
    setWPM(0);
    setErrors(0);
  };

  const callbackRef = useCallback((input) => {
    if (input) {
      input.focus();
    }
  }, []);

  return (
    <>
      <div className="practiceB-css bg-ctr">
        <div className="go-back">
          <Link to="/explore" style={{color:"white"}}><BsArrowLeft /></Link>
        </div>
        <p>Error limit set to 1 Character</p>

        {showNotification && 
          <CenteredMessage 
            message="Oops, made a mistake. GAME OVER!" 
            onClose={handleCloseNotification} 
          />
        }

        <div className="wpm-acc">
          <p>
            {Math.floor(WPM)}
            <small> WPM</small>
          </p>
          <p>
            {Math.floor(errors)}
            <small> Error</small>
          </p>
        </div>

        {(!showNotification) && 
          <input
            type='text'
            value={word}
            autoFocus
            onChange={handleWordType}
            ref={callbackRef}
            style={{ opacity: 0 }}
          />
        }

        <Characters
          para={para}
          word={word}
          chrIndex={chrIndex}
        />
      </div>
    </>
  );
};

export default ErrorMode;
